// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_mainContainer__x0B7p {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.styles_innerContainer__oylfL {
  gap: 10px;
  padding: 32px;
  border-radius: 8px;
  background-color: #175ce5;
}

.styles_formContainer__aOjgB {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 32px;
  padding: 32px;
  border-radius: 8px;
  border: solid 1px #f0f0f0;
  background-color: #fff;
}

.styles_heading__e40Df {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  padding: 0;
}
.styles_heading__e40Df .styles_subtitle__8RCzB {
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000;
}

.styles_device__iN6T3 {
  flex-grow: 1;
  font-family: Poppins;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #24b237;
}
.styles_device__iN6T3 .styles_manager__wBOIr {
  color: #051433;
}

.styles_inputContainer__LqCN1 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  gap: 16px;
  padding: 0;
}

.styles_bottomContainer__ub-Va {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.styles_bottomContainer__ub-Va .styles_forgotPassword__qKx10 {
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #0250ee;
  cursor: pointer;
}
.styles_bottomContainer__ub-Va .styles_signinBtn__MvGKF {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  border-radius: 4px;
  background-color: #0250ee;
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #fff;
}
.styles_bottomContainer__ub-Va .styles_signinBtn__MvGKF:hover {
  background-color: #0250ee;
  opacity: 0.8;
}
.styles_bottomContainer__ub-Va .styles_signinBtn__MvGKF:disabled {
  opacity: 0.5;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/Auth/Login/components/AuthLayout/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;AACJ;;AAEA;EACI,SAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;AACJ;AAAI;EACI,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;AAER;;AAEA;EACI,YAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AACJ;AAAI;EACI,cAAA;AAER;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AAAI;EACI,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AAER;AAAI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;AAER;AADQ;EACI,yBAAA;EACA,YAAA;AAGZ;AADQ;EACI,YAAA;EACA,WAAA;AAGZ","sourcesContent":[".mainContainer{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100vh;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n\n.innerContainer{\n    gap: 10px;\n    padding: 32px;\n    border-radius: 8px;\n    background-color: #175ce5;\n}\n\n.formContainer{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 32px;\n    padding: 32px;\n    border-radius: 8px;\n    border: solid 1px #f0f0f0;\n    background-color: #fff;\n}\n\n.heading{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 4px;\n    padding: 0;\n    .subtitle{\n        font-family: Poppins;\n        font-size: 16px;\n        font-weight: 500;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.5;\n        letter-spacing: normal;\n        color: #000;\n    }\n}\n\n.device{\n    flex-grow: 1;\n    font-family: Poppins;\n    font-size: 16px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: center;\n    color: #24b237;\n    .manager {\n        color: #051433;\n    }\n}\n\n.inputContainer{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    width: 100%;\n    gap: 16px;\n    padding: 0;\n}\n\n.bottomContainer{\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    .forgotPassword{\n        font-family: Poppins;\n        font-size: 14px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.71;\n        letter-spacing: normal;\n        color: #0250ee;\n        cursor: pointer;\n    }\n    .signinBtn{\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        padding: 8px 16px;\n        border-radius: 4px;\n        background-color: #0250ee;\n        font-family: Poppins;\n        font-size: 14px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.71;\n        letter-spacing: normal;\n        color: #fff;\n        &:hover{\n            background-color: #0250ee;\n            opacity: 0.8;\n        }\n        &:disabled{\n            opacity: 0.5;\n            color: #fff;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `styles_mainContainer__x0B7p`,
	"innerContainer": `styles_innerContainer__oylfL`,
	"formContainer": `styles_formContainer__aOjgB`,
	"heading": `styles_heading__e40Df`,
	"subtitle": `styles_subtitle__8RCzB`,
	"device": `styles_device__iN6T3`,
	"manager": `styles_manager__wBOIr`,
	"inputContainer": `styles_inputContainer__LqCN1`,
	"bottomContainer": `styles_bottomContainer__ub-Va`,
	"forgotPassword": `styles_forgotPassword__qKx10`,
	"signinBtn": `styles_signinBtn__MvGKF`
};
export default ___CSS_LOADER_EXPORT___;
